class s{}export{s as IEvents};
//# sourceMappingURL=index.es.js.map
